import Api from "@/api/index.js"

const Employee = {
  namespaced: true,
  state: { 
    oneEmployee: null, 
    allEmployees: null, 
  },
  mutations: {
    getEmployees(state, employees) {
      state.allEmployees = employees;

    },
    getOneEmployee(state, employee) {
      state.oneEmployee = employee;
    },
    resetEmployee(state, employee){
      state.oneEmployee = {
        ...state.oneEmployee,
        ...employee
      }
    },
    clearEmployee(state){
      state.oneEmployee = null
    },
    clearAllEmployee(state){
      state.allEmployees = null
    },
  },
  actions: { 
    index(context, {filter}) {
      Api.Employee.index(filter)
        .then(response => response.data)
        .then(employees => {
          context.commit('getEmployees', employees);
        }).catch(function (error) {
          console.log(error);
        });
    },
    show(context, {employee_id, filter}) {
      Api.Employee.show(employee_id, filter)
        .then(response => response.data)
        .then(employee => {
          context.commit('getOneEmployee', employee)
        }).catch(function (error) {
          console.log(error);
        });
    },
    clearEmployee(context){
      context.commit('clearEmployee')
    },
    clearAllEmployee(context){
      context.commit('clearAllEmployee')
    },
  }
};

export default Employee;
